// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login page specific styles - using mgb-login prefix to avoid conflicts */
.mgb-login * {
  box-sizing: border-box;
}

/* No global body styles to prevent affecting other pages */

.mgb-login-page {
  font-family: 'Montserrat', sans-serif;
  background: linear-gradient(135deg, #1a5276, #2e86c1, #3498db);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

/* Background pattern */
.mgb-login-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 8%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.1) 0%, transparent 8%);
  background-size: 50px 50px;
  opacity: 0.4;
}

.mgb-login-container {
  position: relative;
  width: 950px;
  max-width: 95%;
  perspective: 1000px;
  z-index: 1;
}

/* Login card */
.mgb-login-card {
  display: flex;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25), 
              0 10px 20px rgba(0, 0, 0, 0.22);
  overflow: hidden;
  position: relative;
  z-index: 2;
  min-height: 550px;
}

/* Card backdrop element for design enhancement */
.mgb-login-card-backdrop {
  position: absolute;
  content: '';
  width: 95%;
  height: 90%;
  top: 5%;
  left: 2.5%;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  backdrop-filter: blur(5px);
  z-index: 1;
}

/* Brand section */
.mgb-login-brand {
  background: linear-gradient(135deg, #2980b9, #1a5276);
  color: #fff;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 40%;
  position: relative;
  overflow: hidden;
}

.mgb-login-brand::after {
  content: '';
  position: absolute;
  bottom: -50px;
  right: -50px;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.mgb-login-brand::before {
  content: '';
  position: absolute;
  top: -30px;
  left: -30px;
  width: 120px;
  height: 120px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.mgb-brand-logo {
  width: 80px;
  height: 80px;
  background-color: #fff;
  border-radius: 16px;
  margin-bottom: 2rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
}

.mgb-brand-logo::before {
  content: "MGB";
  color: #1a5276;
  font-weight: bold;
  font-size: 1.5rem;
}

.mgb-login-brand h1 {
  font-size: 2.2rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.mgb-login-brand p {
  font-size: 1rem;
  opacity: 0.8;
  margin-bottom: 2rem;
}

/* Form container */
.mgb-login-form-container {
  flex: 1 1;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mgb-login-form-container h2 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.mgb-login-subtitle {
  font-size: 0.9rem;
  color: #7f8c8d;
  margin-bottom: 2rem;
}

/* Form elements */
.mgb-login-form {
  width: 100%;
}

.mgb-input-group {
  margin-bottom: 1.5rem;
}

.mgb-input-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #34495e;
  font-weight: 500;
}

.mgb-input-with-icon {
  position: relative;
}

.mgb-input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #95a5a6;
  font-size: 1rem;
}

.mgb-login-input {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s;
  background-color: #f9f9f9;
}

.mgb-login-input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
  background-color: #fff;
}

.mgb-login-input::placeholder {
  color: #bdc3c7;
}

.mgb-forgot-password {
  text-align: right;
  margin-bottom: 1.5rem;
}

.mgb-forgot-password a {
  color: #3498db;
  font-size: 0.85rem;
  text-decoration: none;
  transition: color 0.3s;
}

.mgb-forgot-password a:hover {
  color: #2980b9;
  text-decoration: underline;
}

/* Login button */
.mgb-login-button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(to right, #3498db, #2980b9);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(41, 128, 185, 0.3);
}

.mgb-login-button:hover {
  background: linear-gradient(to right, #2980b9, #1a5276);
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(41, 128, 185, 0.4);
}

.mgb-login-button:active {
  transform: translateY(1px);
}

.mgb-login-button:disabled {
  background: #95a5a6;
  cursor: not-allowed;
  box-shadow: none;
}

/* Loading spinner */
.mgb-loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Error message */
.mgb-error-message {
  background-color: #e74c3c;
  color: white;
  padding: 10px 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  animation: slideIn 0.3s ease-out;
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.2);
}

.mgb-error-message::before {
  content: "⚠️";
  margin-right: 8px;
  font-size: 1rem;
}

@keyframes slideIn {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Footer */
.mgb-login-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 15px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  background-color: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
}

.mgb-login-footer a {
  color: white;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s;
}

.mgb-login-footer a:hover {
  color: #3498db;
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
}

/* Responsive Design */
@media (max-width: 900px) {
  .mgb-login-card {
    flex-direction: column;
    min-height: auto;
  }
  
  .mgb-login-brand {
    width: 100%;
    padding: 2rem;
    min-height: 200px;
  }
  
  .mgb-login-form-container {
    padding: 2rem;
  }
  
  .mgb-brand-logo {
    width: 60px;
    height: 60px;
    margin-bottom: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Login/Login.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;EACE,sBAAsB;AACxB;;AAEA,2DAA2D;;AAE3D;EACE,qCAAqC;EACrC,8DAA8D;EAC9D,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;mFAEiF;EACjF,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB;6CAC2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,OAAO;EACP,UAAU;EACV,2CAA2C;EAC3C,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;EACb,uDAAuD;EACvD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,uDAAuD;EACvD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF","sourcesContent":["/* Login page specific styles - using mgb-login prefix to avoid conflicts */\r\n.mgb-login * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* No global body styles to prevent affecting other pages */\r\n\r\n.mgb-login-page {\r\n  font-family: 'Montserrat', sans-serif;\r\n  background: linear-gradient(135deg, #1a5276, #2e86c1, #3498db);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n  position: relative;\r\n  overflow: hidden;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* Background pattern */\r\n.mgb-login-page::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-image: \r\n    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 8%),\r\n    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.1) 0%, transparent 8%);\r\n  background-size: 50px 50px;\r\n  opacity: 0.4;\r\n}\r\n\r\n.mgb-login-container {\r\n  position: relative;\r\n  width: 950px;\r\n  max-width: 95%;\r\n  perspective: 1000px;\r\n  z-index: 1;\r\n}\r\n\r\n/* Login card */\r\n.mgb-login-card {\r\n  display: flex;\r\n  background-color: #fff;\r\n  border-radius: 16px;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25), \r\n              0 10px 20px rgba(0, 0, 0, 0.22);\r\n  overflow: hidden;\r\n  position: relative;\r\n  z-index: 2;\r\n  min-height: 550px;\r\n}\r\n\r\n/* Card backdrop element for design enhancement */\r\n.mgb-login-card-backdrop {\r\n  position: absolute;\r\n  content: '';\r\n  width: 95%;\r\n  height: 90%;\r\n  top: 5%;\r\n  left: 2.5%;\r\n  background-color: rgba(255, 255, 255, 0.05);\r\n  border-radius: 12px;\r\n  backdrop-filter: blur(5px);\r\n  z-index: 1;\r\n}\r\n\r\n/* Brand section */\r\n.mgb-login-brand {\r\n  background: linear-gradient(135deg, #2980b9, #1a5276);\r\n  color: #fff;\r\n  padding: 3rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  width: 40%;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.mgb-login-brand::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -50px;\r\n  right: -50px;\r\n  width: 200px;\r\n  height: 200px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border-radius: 50%;\r\n}\r\n\r\n.mgb-login-brand::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: -30px;\r\n  left: -30px;\r\n  width: 120px;\r\n  height: 120px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border-radius: 50%;\r\n}\r\n\r\n.mgb-brand-logo {\r\n  width: 80px;\r\n  height: 80px;\r\n  background-color: #fff;\r\n  border-radius: 16px;\r\n  margin-bottom: 2rem;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.mgb-brand-logo::before {\r\n  content: \"MGB\";\r\n  color: #1a5276;\r\n  font-weight: bold;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.mgb-login-brand h1 {\r\n  font-size: 2.2rem;\r\n  margin-bottom: 1rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.mgb-login-brand p {\r\n  font-size: 1rem;\r\n  opacity: 0.8;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n/* Form container */\r\n.mgb-login-form-container {\r\n  flex: 1;\r\n  padding: 3rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.mgb-login-form-container h2 {\r\n  font-size: 1.8rem;\r\n  color: #2c3e50;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.mgb-login-subtitle {\r\n  font-size: 0.9rem;\r\n  color: #7f8c8d;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n/* Form elements */\r\n.mgb-login-form {\r\n  width: 100%;\r\n}\r\n\r\n.mgb-input-group {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.mgb-input-group label {\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n  font-size: 0.9rem;\r\n  color: #34495e;\r\n  font-weight: 500;\r\n}\r\n\r\n.mgb-input-with-icon {\r\n  position: relative;\r\n}\r\n\r\n.mgb-input-icon {\r\n  position: absolute;\r\n  left: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #95a5a6;\r\n  font-size: 1rem;\r\n}\r\n\r\n.mgb-login-input {\r\n  width: 100%;\r\n  padding: 12px 12px 12px 40px;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  transition: all 0.3s;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.mgb-login-input:focus {\r\n  outline: none;\r\n  border-color: #3498db;\r\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);\r\n  background-color: #fff;\r\n}\r\n\r\n.mgb-login-input::placeholder {\r\n  color: #bdc3c7;\r\n}\r\n\r\n.mgb-forgot-password {\r\n  text-align: right;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.mgb-forgot-password a {\r\n  color: #3498db;\r\n  font-size: 0.85rem;\r\n  text-decoration: none;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.mgb-forgot-password a:hover {\r\n  color: #2980b9;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Login button */\r\n.mgb-login-button {\r\n  width: 100%;\r\n  padding: 14px;\r\n  background: linear-gradient(to right, #3498db, #2980b9);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 15px rgba(41, 128, 185, 0.3);\r\n}\r\n\r\n.mgb-login-button:hover {\r\n  background: linear-gradient(to right, #2980b9, #1a5276);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 18px rgba(41, 128, 185, 0.4);\r\n}\r\n\r\n.mgb-login-button:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.mgb-login-button:disabled {\r\n  background: #95a5a6;\r\n  cursor: not-allowed;\r\n  box-shadow: none;\r\n}\r\n\r\n/* Loading spinner */\r\n.mgb-loading-spinner {\r\n  display: inline-block;\r\n  width: 20px;\r\n  height: 20px;\r\n  border: 3px solid rgba(255, 255, 255, 0.3);\r\n  border-radius: 50%;\r\n  border-top-color: #fff;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Error message */\r\n.mgb-error-message {\r\n  background-color: #e74c3c;\r\n  color: white;\r\n  padding: 10px 15px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n  font-size: 0.9rem;\r\n  display: flex;\r\n  align-items: center;\r\n  animation: slideIn 0.3s ease-out;\r\n  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.2);\r\n}\r\n\r\n.mgb-error-message::before {\r\n  content: \"⚠️\";\r\n  margin-right: 8px;\r\n  font-size: 1rem;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    transform: translateY(-10px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Footer */\r\n.mgb-login-footer {\r\n  position: absolute;\r\n  bottom: 0;\r\n  width: 100%;\r\n  padding: 15px;\r\n  text-align: center;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 0.85rem;\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.mgb-login-footer a {\r\n  color: white;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.mgb-login-footer a:hover {\r\n  color: #3498db;\r\n  text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 900px) {\r\n  .mgb-login-card {\r\n    flex-direction: column;\r\n    min-height: auto;\r\n  }\r\n  \r\n  .mgb-login-brand {\r\n    width: 100%;\r\n    padding: 2rem;\r\n    min-height: 200px;\r\n  }\r\n  \r\n  .mgb-login-form-container {\r\n    padding: 2rem;\r\n  }\r\n  \r\n  .mgb-brand-logo {\r\n    width: 60px;\r\n    height: 60px;\r\n    margin-bottom: 1rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
